import CameraIcon from '../../../../images/camera.svg?component';
import ROUTE_NAMES from '../../routeNames';
import SECTION_NAMES from '../../sectionNames';
import { usePermissionsStore } from '@/vue/stores/permissions';

const meta = {
    title: SECTION_NAMES.ROOMS_AND_DEVICES,
    permissions: (): string[] => [usePermissionsStore().allPermissions.adminRooms],
    icon: CameraIcon,
};

const AdminStreamView = () => import('../../../views/admin/AdminDevice/AdminStreamView.vue');
export default [
    {
        path: 'stream/new',
        name: ROUTE_NAMES.ADMIN_STREAM_NEW,
        component: AdminStreamView,
        meta: { new: true, ...meta },
    },
    {
        path: 'stream/edit/:id',
        name: ROUTE_NAMES.ADMIN_STREAM_VIEW,
        component: AdminStreamView,
        meta: { new: false, ...meta },
    },
];
